import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-bharat-blue text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img 
              src="/logo-secondary-white.png" 
              alt="Bharat Enterprises"
              className="h-16 mb-4"
            />
            <p className="text-white/80 mb-4 leading-relaxed">
              India's trusted Titanium Dioxide distribution partner. Serving 1000+ SME and MSME 
              manufacturers with reliable supply and competitive pricing.
            </p>
            <div className="flex items-center space-x-2 text-manufacturing-orange font-semibold">
              <div className="w-2 h-2 bg-manufacturing-orange rounded-full"></div>
              <span>40+ Years of Excellence</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-white/80 hover:text-manufacturing-orange transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('products')}
                  className="text-white/80 hover:text-manufacturing-orange transition-colors"
                >
                  Products
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('industries')}
                  className="text-white/80 hover:text-manufacturing-orange transition-colors"
                >
                  Industries
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('why-us')}
                  className="text-white/80 hover:text-manufacturing-orange transition-colors"
                >
                  Why Choose Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-white/80 hover:text-manufacturing-orange transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-1 text-manufacturing-orange" />
                <span className="text-white/80 text-sm">
                  A-51, GT Karnal Road Industrial Area, Delhi – 110033
                </span>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="w-5 h-5 flex-shrink-0 mt-1 text-manufacturing-orange" />
                <a 
                  href="mailto:info@bharatenterprises.org"
                  className="text-white/80 hover:text-manufacturing-orange transition-colors text-sm"
                >
                  info@bharatenterprises.org
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="w-5 h-5 flex-shrink-0 mt-1 text-manufacturing-orange" />
                <a 
                  href="tel:+919999996696"
                  className="text-white/80 hover:text-manufacturing-orange transition-colors text-sm"
                >
                  +91 99999 96696
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/70 text-sm">
              © {currentYear} Bharat Enterprises. All rights reserved.
            </p>
            <p className="text-white/70 text-sm italic">
              "Built on Quality. Delivered with Trust."
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
